// The rules the create password screen ticks off as someone types.
//
// `required` is what SAVE PASSWORD waits for. It mirrors the server rule on
// User (PASSWORD_COMPLEXITY_REGEX plus Devise's minimum length), so a password
// that turns every required tick green is one the server will accept — the
// letters rule asks for both cases because the server does.
//
// Special characters are encouraged, never required, so that tick can stay grey
// without stopping anyone saving.
export const PASSWORD_RULES = [
  {key: 'length', required: true, met: (password) => password.length >= 8},
  {key: 'number', required: true, met: (password) => /\d/.test(password)},
  {
    key: 'letters',
    required: true,
    met: (password) => /[a-z]/.test(password) && /[A-Z]/.test(password),
  },
  {
    key: 'special',
    required: false,
    met: (password) => /[^A-Za-z0-9]/.test(password),
  },
]

export const meetsRequiredRules = (password) =>
  PASSWORD_RULES.filter((rule) => rule.required).every((rule) =>
    rule.met(password),
  )
